module.exports = __webpack_public_path__ + "media/images/application/template/meganav/shipping-containers/6ft-mobile-b2283a4e680f73b6515ea12f7971d865.png";